import { call, put } from 'redux-saga/effects'
import { push } from 'react-router-redux'

export const is_ok = data =>
  data && !data.error && (!data.status || data.status === 'ok')

export const gCall = (api_call, action_succeeded, action_failed, route_succeeded, route_failed) =>
  function* x({ payload }) {
    let action
    const actions_succeeded = action_succeeded && [].concat(action_succeeded)
    const actions_failed = action_failed && [].concat(action_failed)
    const response = yield call(api_call, payload)
    if (is_ok(response.data)) {
      if (actions_succeeded) {
        for (action of actions_succeeded) {
          yield put(action(response.data, payload))
        }
      }
      if (route_succeeded) { yield put(push(route_succeeded(payload))) }
    } else {
      if (actions_failed) {
        for (action of actions_failed) {
          yield put(action(payload))
        }
      }
      if (route_failed) { yield put(push(route_failed(payload))) }
    }
  }

export const redirectTo = route =>
  function* x({ payload }) {
    yield put(push(route(payload)))
  }

export const webOs = () => {
  try {
    if ((!!window.opr && !!window.opr.addons) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0) {
      return 'Opera'
    } else if (typeof InstallTrigger !== 'undefined') {
      return 'Firefox'
    } else if (/* @cc_on!@*/false || !!document.documentMode) {
      return 'IE'
    } else if (!window.isIE && !!window.StyleMedia) {
      return 'Edge'
    } else if (!!window.chrome && !!window.chrome.webstore) {
      return 'Chrome'
    } else if ((window.isChrome || window.isOpera) && !!window.CSS) {
      return 'Blink'
    } else if (/constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === '[object SafariRemoteNotification]' }(!window.safari || (typeof window.safari !== 'undefined' && window.safari.pushNotification)))) {
      return 'Safari'
    }
  } catch (e) {
    return 'Not Found'
  }
}



// WEBPACK FOOTER //
// ./src/sagas/utils.jsx